import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import MembershipsTableRow from './MembershipsTableRow'
import { getSortIndicator } from '@/lib/tableHelpers'

export default function MembershipsTable({
	membershipsData,
	loading,
	selectedMemberships,
	onSelectAll,
	onSelectMembership,
	isAllSelected,
	isIndeterminate,
	sortColumn,
	sortDirection,
	onSort,
}) {
	const columns = [
		{ key: 'customerName', label: 'Customer Name', sortable: true },
		{ key: 'type', label: 'Type', sortable: true },
		{ key: 'status', label: 'Status', sortable: true },
		{ key: 'remainingUsage', label: 'Remaining Usage', sortable: true },
		{ key: 'expiryDate', label: 'Expiry Date', sortable: true },
	]

	if (loading) {
		return <LoadingIndicator />
	}

	if (!membershipsData || membershipsData.length === 0) {
		return <NoResultsIndicator message="No memberships found" />
	}

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left w-12">
							<input
								type="checkbox"
								checked={isAllSelected}
								ref={el => {
									if (el) el.indeterminate = isIndeterminate
								}}
								onChange={e => onSelectAll(e.target.checked)}
								className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
							/>
						</th>
						{columns.map(column => (
							<th key={column.key} className="py-2 px-4 border-b border-gray-300 text-left">
								{column.sortable ? (
									<button
										className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
										onClick={() => onSort(column.key)}>
										{column.label}
										{getSortIndicator(column.key, sortColumn, sortDirection)}
									</button>
								) : (
									<span className="font-semibold text-gray-700">{column.label}</span>
								)}
							</th>
						))}
						<th className="py-2 px-4 border-b border-gray-300 text-right w-24">
							<span className="font-semibold text-gray-700">Actions</span>
						</th>
					</tr>
				</thead>
				<tbody>
					{membershipsData.map(membership => (
						<MembershipsTableRow
							key={membership._id}
							membership={membership}
							isSelected={selectedMemberships.has(membership._id)}
							onSelectMembership={onSelectMembership}
						/>
					))}
				</tbody>
			</table>
		</div>
	)
}
